module.exports = __webpack_public_path__ + "img/avatar-3.c5c13ab6.jpg";